import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navLinks = [
    { label: "Hire Workers", href: "/hire-workers" },
    { label: "Flats & Villas", href: "/real-estate" },
    { label: "Resale Goods", href: "/marketplace" },
  ];

  return (
    <nav className="glass-nav sticky top-0 z-50" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex items-center justify-between h-14">
          <a href="/" className="flex items-center gap-2" data-testid="navbar-logo">
            <div className="w-7 h-7 rounded-lg bg-indigo flex items-center justify-center">
              <span className="text-white font-heading font-bold text-sm">J</span>
            </div>
            <span className="font-heading font-semibold text-base text-indigo tracking-tight">Junction</span>
            <span className="hidden sm:inline text-[10px] font-semibold text-terracotta bg-terracotta/10 px-2 py-0.5 rounded-full ml-1">HYDERABAD</span>
          </a>

          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((l) => (
              <a key={l.label} href={l.href} className="text-[13px] font-medium text-gray-500 hover:text-indigo transition-colors" data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}>{l.label}</a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="text-[13px] font-medium text-gray-500 hover:text-indigo" data-testid="nav-login-dropdown">Log in</button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem asChild><a href="/worker-login" className="cursor-pointer" data-testid="nav-worker-login">Worker Login</a></DropdownMenuItem>
                <DropdownMenuItem asChild><a href="/admin" className="cursor-pointer" data-testid="nav-admin-login">Admin</a></DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>

          <button className="md:hidden p-1.5 text-indigo" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-button">
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
        {mobileOpen && (
          <div className="md:hidden pb-3 border-t border-gray-100" data-testid="mobile-menu">
            <div className="flex flex-col gap-1 pt-2">
              {navLinks.map((l) => (<a key={l.label} href={l.href} className="text-sm text-gray-600 px-2 py-2" onClick={() => setMobileOpen(false)}>{l.label}</a>))}
              <a href="/worker-login" className="text-sm text-gray-600 px-2 py-2">Worker Login</a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
